import { AnnotatedNotitie } from './annotatedNotitieTypes';
import { mergeRanges } from './markCoverage';

const isValidRange = (start: number, end: number, textLength: number): boolean =>
  Number.isInteger(start) && Number.isInteger(end) && start >= 0 && end <= textLength && start < end;

export const getPlainNotitieText = (notitie?: AnnotatedNotitie): string => notitie?.text ?? '';

export const getVisibleNotitieText = (notitie?: AnnotatedNotitie, showPrivateText = true): string => {
  const text = getPlainNotitieText(notitie);
  if (!notitie || showPrivateText || !text) return text;

  const privateRanges = mergeRanges(
    notitie.marks
      .filter((mark) => mark.type === 'PRIVATE' && isValidRange(mark.start, mark.end, text.length))
      .map((mark) => ({ start: mark.start, end: mark.end })),
  );

  if (!privateRanges.length) return text;

  let visibleText = '';
  let cursor = 0;

  for (const range of privateRanges) {
    if (range.start > cursor) {
      visibleText += text.slice(cursor, range.start);
    }
    cursor = Math.max(cursor, range.end);
  }

  return `${visibleText}${text.slice(cursor)}`;
};
